// // // // import React, { useEffect, useState, useCallback } from 'react';
// // // // import {
// // // //   Box, Typography, Chip, IconButton, Tooltip, Button, TextField, InputAdornment,
// // // // } from '@mui/material';
// // // // import HistoryIcon from '@mui/icons-material/History';
// // // // import VisibilityIcon from '@mui/icons-material/Visibility';
// // // // import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
// // // // import SearchIcon from '@mui/icons-material/Search';
// // // // import TableComponent from '../../../Components/TableComponent/TableComponent';
// // // // import { LoadingSpinner } from '../../../Components/spinner/spinner';
// // // // import { SnackBarComponent } from '../../../Components/snackBar/snackBar';

// // // // import {
// // // //   fetchMyRecords, STAGES, STAGE_LABELS, STAGE_COLORS,
// // // //   GENERIC_FORWARD_RETURN_ROLES,
// // // // } from './workflowApi';
// // // // import CaseWorkerDecisionDialog from './caseworkerDecisionDialog';
// // // // import ForensicAuditorActionDialog from './forensicAuditorActionDialog';
// // // // import ForwardReturnDialog from './forwordReturnDialog';
// // // // import WorkflowHistoryDialog from './workHistoryDialog';
// // // // import RecordDetailDialog from './recordDetails';
// // // // import ExcessManageModal from './epmsMgmtModal';

// // // // // Every record this role has visibility into, regardless of current stage —
// // // // // full document/order/payment detail on every row, and inline action when
// // // // // `can_act` says it's actually this role's turn.
// // // // const MyRecordsTable = ({ role, title = 'My Records' }) => {
// // // //   const [rows, setRows] = useState([]);
// // // //   const [loading, setLoading] = useState(false);
// // // //   const [search, setSearch] = useState('');
// // // //   const [activeRow, setActiveRow] = useState(null);
// // // //   const [dialogType, setDialogType] = useState(null); // 'action' | 'history' | 'manage' | 'detail'

// // // //   const [snackbarOpen, setSnackbarOpen] = useState(false);
// // // //   const [snackbarMsg, setSnackbarMsg] = useState('');
// // // //   const [snackbarSeverity, setSnackbarSeverity] = useState('info');

// // // //   const showSuccess = (msg) => { setSnackbarMsg(msg); setSnackbarSeverity('success'); setSnackbarOpen(true); };
// // // //   const showError = (msg) => { setSnackbarMsg(msg); setSnackbarSeverity('error'); setSnackbarOpen(true); };

// // // //   const loadRecords = useCallback(() => {
// // // //     setLoading(true);
// // // //     fetchMyRecords()
// // // //       .then((res) => setRows(res.data?.results || []))
// // // //       .catch(() => showError('Failed to load records.'))
// // // //       .finally(() => setLoading(false));
// // // //   }, []);

// // // //   useEffect(() => { loadRecords(); }, [loadRecords]);

// // // //   const closeDialogs = () => {
// // // //     setActiveRow(null);
// // // //     setDialogType(null);
// // // //   };

// // // //   const handleDialogSuccess = (msg) => {
// // // //     showSuccess(msg);
// // // //     closeDialogs();
// // // //     loadRecords();
// // // //   };

// // // //   const handleActionClick = (row) => {
// // // //     if (row.current_stage === STAGES.PENDING_PAYMENT) {
// // // //       setActiveRow(row);
// // // //       setDialogType('manage');
// // // //       return;
// // // //     }
// // // //     setActiveRow(row);
// // // //     setDialogType('action');
// // // //   };

// // // //   const filteredRows = search.trim()
// // // //     ? rows.filter((r) =>
// // // //         r.reference_id?.toLowerCase().includes(search.toLowerCase()) ||
// // // //         r.name?.toLowerCase().includes(search.toLowerCase()) ||
// // // //         r.fe_name?.toLowerCase().includes(search.toLowerCase())
// // // //       )
// // // //     : rows;

// // // //   const columns = [
// // // //     { id: 'reference_id', field: 'reference_id', headerName: 'Reference ID', width: 150 },
// // // //     { id: 'name', field: 'name', headerName: 'Name', width: 160 },
// // // //     { id: 'fe_name', field: 'fe_name', headerName: 'FE', width: 160 },
// // // //     {
// // // //       id: 'workflow_type', field: 'workflow_type', headerName: 'Workflow', width: 100,
// // // //       renderCell: (params) => params.row.workflow_type
// // // //         ? <Chip size="small" label={params.row.workflow_type === 'workflow_1' ? 'WF 1' : 'WF 2'} />
// // // //         : <Typography variant="caption" color="text.secondary">—</Typography>,
// // // //     },
// // // //     {
// // // //       id: 'current_stage', field: 'current_stage', headerName: 'Stage', width: 220,
// // // //       renderCell: (params) => (
// // // //         <Chip
// // // //           size="small"
// // // //           label={STAGE_LABELS[params.row.current_stage] || params.row.current_stage}
// // // //           color={STAGE_COLORS[params.row.current_stage] || 'default'}
// // // //           sx={{ fontWeight: 600 }}
// // // //         />
// // // //       ),
// // // //     },
// // // //     { id: 'excess_amount', field: 'excess_amount', headerName: 'Excess Amount', width: 130 },
// // // //     {
// // // //       id: 'actions', field: 'actions', headerName: 'Actions', width: 220, sortable: false,
// // // //       renderCell: (params) => (
// // // //         <Box display="flex" alignItems="center" gap={0.5}>
// // // //           <Tooltip title="View full details">
// // // //             <IconButton size="small" onClick={() => { setActiveRow(params.row); setDialogType('detail'); }}>
// // // //               <VisibilityIcon fontSize="small" />
// // // //             </IconButton>
// // // //           </Tooltip>
// // // //           {params.row.can_act && (
// // // //             <Button
// // // //               size="small"
// // // //               variant="contained"
// // // //               startIcon={<AssignmentTurnedInIcon fontSize="small" />}
// // // //               onClick={() => handleActionClick(params.row)}
// // // //             >
// // // //               {params.row.current_stage === STAGES.PENDING_PAYMENT ? 'Manage Payment' : 'Act'}
// // // //             </Button>
// // // //           )}
// // // //           <Tooltip title="View History">
// // // //             <IconButton size="small" onClick={() => { setActiveRow(params.row); setDialogType('history'); }}>
// // // //               <HistoryIcon fontSize="small" />
// // // //             </IconButton>
// // // //           </Tooltip>
// // // //         </Box>
// // // //       ),
// // // //     },
// // // //   ];

// // // //   const isGenericRole = GENERIC_FORWARD_RETURN_ROLES.has(role);

// // // //   return (
// // // //     <Box sx={{ width: '100%', bgcolor: '#fff', borderRadius: 2, boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }}>
// // // //       <Box p={2} display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={1.5} bgcolor="rgba(195,234,203,0.1)">
// // // //         <Typography variant="h6" fontWeight="bold">{title}</Typography>
// // // //         <Box display="flex" alignItems="center" gap={2}>
// // // //           <TextField
// // // //             size="small"
// // // //             placeholder="Search reference ID, name, FE..."
// // // //             value={search}
// // // //             onChange={(e) => setSearch(e.target.value)}
// // // //             InputProps={{ startAdornment: <InputAdornment position="start"><SearchIcon fontSize="small" /></InputAdornment> }}
// // // //           />
// // // //           <Typography variant="body2" color="text.secondary">
// // // //             {filteredRows.length} record(s)
// // // //           </Typography>
// // // //         </Box>
// // // //       </Box>

// // // //       {loading ? (
// // // //         <LoadingSpinner size={30} />
// // // //       ) : filteredRows.length === 0 ? (
// // // //         <Box p={4} textAlign="center">
// // // //           <Typography color="text.secondary">
// // // //             {rows.length === 0
// // // //               ? 'No records assigned to you yet.'
// // // //               : 'No records match your search.'}
// // // //           </Typography>
// // // //         </Box>
// // // //       ) : (
// // // //         <TableComponent
// // // //           columns={columns}
// // // //           rows={filteredRows}
// // // //           manageColumnStatus
// // // //           enableSort
// // // //           sx={{ '& .MuiDataGrid-columnHeaders': { backgroundColor: '#1976d2', color: '#fff', fontWeight: 'bold' } }}
// // // //         />
// // // //       )}

// // // //       {/* Detail view — always available */}
// // // //       {activeRow && dialogType === 'detail' && (
// // // //         <RecordDetailDialog open onClose={closeDialogs} record={activeRow} />
// // // //       )}

// // // //       {/* Case Worker — initial decision */}
// // // //       {activeRow && dialogType === 'action' && role === 'case_worker' && (
// // // //         <CaseWorkerDecisionDialog
// // // //           open
// // // //           onClose={closeDialogs}
// // // //           excessId={activeRow.id}
// // // //           refId={activeRow.reference_id}
// // // //           excessAmt={activeRow.excess_amount}
// // // //           onSuccess={handleDialogSuccess}
// // // //           onError={showError}
// // // //         />
// // // //       )}

// // // //       {/* Forensic Auditor — report + forward/return */}
// // // //       {activeRow && dialogType === 'action' && role === 'forensic_auditor' && (
// // // //         <ForensicAuditorActionDialog
// // // //           open
// // // //           onClose={closeDialogs}
// // // //           excessId={activeRow.id}
// // // //           refId={activeRow.reference_id}
// // // //           excessAmt={activeRow.excess_amount}
// // // //           onSuccess={handleDialogSuccess}
// // // //           onError={showError}
// // // //         />
// // // //       )}

// // // //       {/* Shirastedar / Tahsildar / AC / CA / SPLOCA — generic forward/return */}
// // // //       {activeRow && dialogType === 'action' && isGenericRole && (
// // // //         <ForwardReturnDialog
// // // //           open
// // // //           onClose={closeDialogs}
// // // //           excessId={activeRow.id}
// // // //           refId={activeRow.reference_id}
// // // //           role={role}
// // // //           currentStage={activeRow.current_stage}
// // // //           stageLabel={STAGE_LABELS[activeRow.current_stage] || activeRow.current_stage}
// // // //           onSuccess={handleDialogSuccess}
// // // //           onError={showError}
// // // //         />
// // // //       )}

// // // //       {/* Case Worker at pending_payment — reuse the existing manage modal */}
// // // //       {activeRow && dialogType === 'manage' && (
// // // //         <ExcessManageModal
// // // //           open
// // // //           onClose={closeDialogs}
// // // //           excessId={activeRow.id}
// // // //           refId={activeRow.reference_id}
// // // //           excessAmt={activeRow.excess_amount}
// // // //         />
// // // //       )}

// // // //       {/* History */}
// // // //       {activeRow && dialogType === 'history' && (
// // // //         <WorkflowHistoryDialog
// // // //           open
// // // //           onClose={closeDialogs}
// // // //           excessId={activeRow.id}
// // // //           refId={activeRow.reference_id}
// // // //         />
// // // //       )}

// // // //       <SnackBarComponent
// // // //         open={snackbarOpen}
// // // //         message={snackbarMsg}
// // // //         severity={snackbarSeverity}
// // // //         onClose={() => setSnackbarOpen(false)}
// // // //       />
// // // //     </Box>
// // // //   );
// // // // };

// // // // export default MyRecordsTable;


// // // import React, { useEffect, useState, useCallback } from 'react';
// // // import {
// // //   Box, Typography, Chip, IconButton, Tooltip, Button,
// // //   FormControl, InputLabel, Select, MenuItem,
// // // } from '@mui/material';
// // // import HistoryIcon from '@mui/icons-material/History';
// // // import VisibilityIcon from '@mui/icons-material/Visibility';
// // // import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
// // // import TableComponent from '../../../Components/TableComponent/TableComponent';
// // // import { LoadingSpinner } from '../../../Components/spinner/spinner';
// // // import { SnackBarComponent } from '../../../Components/snackBar/snackBar';

// // // import {
// // //   fetchMyRecords, fetchMyFeList, STAGES, STAGE_LABELS, STAGE_COLORS,
// // //   GENERIC_FORWARD_RETURN_ROLES,
// // // } from './workflowApi';


// // // import CaseWorkerDecisionDialog from './caseworkerDecisionDialog';
// // // import ForensicAuditorActionDialog from './forensicAuditorActionDialog';
// // // import ForwardReturnDialog from './forwordReturnDialog';
// // // import WorkflowHistoryDialog from './workHistoryDialog';
// // // import RecordDetailDialog from './recordDetails';
// // // import ExcessManageModal from './epmsMgmtModal';



// // // const fmtMoney = (n) => `₹ ${Number(n || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`;

// // // // Roles that have visibility across multiple FEs and therefore benefit from
// // // // an FE filter dropdown. Competent Authority only sees their assigned FEs
// // // // (via FeCA); SPLOCA sees every FE.
// // // const FE_FILTERABLE_ROLES = new Set(['competent_authority', 'sploca']);

// // // // Every record this role has visibility into, regardless of current stage —
// // // // full document/order/payment detail on every row, and inline action when
// // // // `can_act` says it's actually this role's turn. No search box here — the
// // // // TableComponent already provides column-level search/filter.
// // // const MyRecordsTable = ({ role, title = 'My Records' }) => {
// // //   const [rows, setRows] = useState([]);
// // //   const [loading, setLoading] = useState(false);
// // //   const [activeRow, setActiveRow] = useState(null);
// // //   const [dialogType, setDialogType] = useState(null); // 'action' | 'history' | 'manage' | 'detail'

// // //   const [feOptions, setFeOptions] = useState([]);
// // //   const [selectedFeId, setSelectedFeId] = useState('');
// // //   const isFeFilterable = FE_FILTERABLE_ROLES.has(role);

// // //   const [snackbarOpen, setSnackbarOpen] = useState(false);
// // //   const [snackbarMsg, setSnackbarMsg] = useState('');
// // //   const [snackbarSeverity, setSnackbarSeverity] = useState('info');

// // //   const showSuccess = (msg) => { setSnackbarMsg(msg); setSnackbarSeverity('success'); setSnackbarOpen(true); };
// // //   const showError = (msg) => { setSnackbarMsg(msg); setSnackbarSeverity('error'); setSnackbarOpen(true); };

// // //   useEffect(() => {
// // //     if (!isFeFilterable) return;
// // //     fetchMyFeList()
// // //       .then((res) => setFeOptions(res.data?.results || []))
// // //       .catch(() => setFeOptions([]));
// // //   }, [isFeFilterable]);

// // //   const loadRecords = useCallback(() => {
// // //     setLoading(true);
// // //     fetchMyRecords({ feId: selectedFeId || undefined })
// // //       .then((res) => setRows(res.data?.results || []))
// // //       .catch(() => showError('Failed to load records.'))
// // //       .finally(() => setLoading(false));
// // //   }, [selectedFeId]);

// // //   useEffect(() => { loadRecords(); }, [loadRecords]);

// // //   const closeDialogs = () => {
// // //     setActiveRow(null);
// // //     setDialogType(null);
// // //   };

// // //   const handleDialogSuccess = (msg) => {
// // //     showSuccess(msg);
// // //     closeDialogs();
// // //     loadRecords();
// // //   };

// // //   const handleActionClick = (row) => {
// // //     if (row.current_stage === STAGES.PENDING_PAYMENT) {
// // //       setActiveRow(row);
// // //       setDialogType('manage');
// // //       return;
// // //     }
// // //     setActiveRow(row);
// // //     setDialogType('action');
// // //   };

// // //   const columns = [
// // //     { id: 'reference_id', field: 'reference_id', headerName: 'Reference ID', width: 150 },
// // //     { id: 'name', field: 'name', headerName: 'Name', width: 150 },
// // //     { id: 'fe_name', field: 'fe_name', headerName: 'FE', width: 150 },
// // //     {
// // //       id: 'workflow_type', field: 'workflow_type', headerName: 'Workflow', width: 100,
// // //       renderCell: (params) => params.row.workflow_type
// // //         ? <Chip size="small" label={params.row.workflow_type === 'workflow_1' ? 'WF 1' : 'WF 2'} />
// // //         : <Typography variant="caption" color="text.secondary">—</Typography>,
// // //     },
// // //     {
// // //       id: 'current_stage', field: 'current_stage', headerName: 'Stage', width: 200,
// // //       renderCell: (params) => (
// // //         <Box display="flex" alignItems="center" gap={0.5}>
// // //           <Chip
// // //             size="small"
// // //             label={STAGE_LABELS[params.row.current_stage] || params.row.current_stage}
// // //             color={STAGE_COLORS[params.row.current_stage] || 'default'}
// // //             sx={{ fontWeight: 600 }}
// // //           />
// // //           {params.row.is_returned && (
// // //             <Chip size="small" label="Returned" color="error" variant="outlined" sx={{ fontWeight: 600 }} />
// // //           )}
// // //         </Box>
// // //       ),
// // //     },
// // //     {
// // //       id: 'agree_to_pay', field: 'agree_to_pay', headerName: 'Agreed to Pay', width: 130,
// // //       renderCell: (params) => {
// // //         const p = params.row.payment;
// // //         if (!p) return <Typography variant="caption" color="text.secondary">—</Typography>;
// // //         if (p.is_agreed_to_pay) return <Chip size="small" label="Agreed" color="success" />;
// // //         if (p.is_not_agreed_to_pay) return <Chip size="small" label="Not Agreed" color="error" />;
// // //         return <Chip size="small" label="Pending" variant="outlined" />;
// // //       },
// // //     },
// // //     {
// // //       id: 'agreed_amount', field: 'agreed_amount', headerName: 'Agreed Amount', width: 140,
// // //       renderCell: (params) => params.row.payment?.agreed_amount
// // //         ? fmtMoney(params.row.payment.agreed_amount)
// // //         : <Typography variant="caption" color="text.secondary">—</Typography>,
// // //     },
// // //     {
// // //       id: 'no_of_installment', field: 'no_of_installment', headerName: 'Installments', width: 110,
// // //       renderCell: (params) => params.row.payment?.no_of_installment || (
// // //         <Typography variant="caption" color="text.secondary">—</Typography>
// // //       ),
// // //     },
// // //     {
// // //       id: 'excess_amount', field: 'excess_amount', headerName: 'Excess Amount', width: 130,
// // //       renderCell: (params) => fmtMoney(params.row.excess_amount),
// // //     },
// // //     {
// // //       id: 'actions', field: 'actions', headerName: 'Actions', width: 240, sortable: false,
// // //       renderCell: (params) => (
// // //         <Box display="flex" alignItems="center" gap={0.5}>
// // //           <Tooltip title="View full details">
// // //             <IconButton size="small" onClick={() => { setActiveRow(params.row); setDialogType('detail'); }}>
// // //               <VisibilityIcon fontSize="small" />
// // //             </IconButton>
// // //           </Tooltip>
// // //           {params.row.can_act && (
// // //             <Button
// // //               size="small"
// // //               variant="contained"
// // //               startIcon={<AssignmentTurnedInIcon fontSize="small" />}
// // //               onClick={() => handleActionClick(params.row)}
// // //             >
// // //               {params.row.current_stage === STAGES.PENDING_PAYMENT ? 'Manage Payment' : 'Act'}
// // //             </Button>
// // //           )}
// // //           <Tooltip title="View History">
// // //             <IconButton size="small" onClick={() => { setActiveRow(params.row); setDialogType('history'); }}>
// // //               <HistoryIcon fontSize="small" />
// // //             </IconButton>
// // //           </Tooltip>
// // //         </Box>
// // //       ),
// // //     },
// // //   ];

// // //   const isGenericRole = GENERIC_FORWARD_RETURN_ROLES.has(role);

// // //   return (
// // //     <Box sx={{ width: '100%', bgcolor: '#fff', borderRadius: 2, boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }}>
// // //       <Box p={2} display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={1.5} bgcolor="rgba(195,234,203,0.1)">
// // //         <Typography variant="h6" fontWeight="bold">{title}</Typography>
// // //         <Box display="flex" alignItems="center" gap={2}>
// // //           {isFeFilterable && (
// // //             <FormControl size="small" sx={{ minWidth: 220 }}>
// // //               <InputLabel>Filter by FE</InputLabel>
// // //               <Select
// // //                 label="Filter by FE"
// // //                 value={selectedFeId}
// // //                 onChange={(e) => setSelectedFeId(e.target.value)}
// // //                 displayEmpty
// // //               >
// // //                 <MenuItem value=""><em>All FE{role === 'sploca' ? ' (State-wide)' : ''}</em></MenuItem>
// // //                 {feOptions.map((fe) => (
// // //                   <MenuItem key={fe.id} value={fe.id}>{fe.name}</MenuItem>
// // //                 ))}
// // //               </Select>
// // //             </FormControl>
// // //           )}
// // //           <Typography variant="body2" color="text.secondary">
// // //             {rows.length} record(s)
// // //           </Typography>
// // //         </Box>
// // //       </Box>

// // //       {loading ? (
// // //         <LoadingSpinner size={30} />
// // //       ) : rows.length === 0 ? (
// // //         <Box p={4} textAlign="center">
// // //           <Typography color="text.secondary">No records assigned to you yet.</Typography>
// // //         </Box>
// // //       ) : (
// // //         <TableComponent
// // //           columns={columns}
// // //           rows={rows}
// // //           manageColumnStatus
// // //           enableSort
// // //           sx={{ '& .MuiDataGrid-columnHeaders': { backgroundColor: '#1976d2', color: '#fff', fontWeight: 'bold' } }}
// // //         />
// // //       )}

// // //       {/* Detail view — always available */}
// // //       {activeRow && dialogType === 'detail' && (
// // //         <RecordDetailDialog open onClose={closeDialogs} record={activeRow} />
// // //       )}

// // //       {/* Case Worker — initial decision */}
// // //       {activeRow && dialogType === 'action' && role === 'case_worker' && (
// // //         <CaseWorkerDecisionDialog
// // //           open
// // //           onClose={closeDialogs}
// // //           excessId={activeRow.id}
// // //           refId={activeRow.reference_id}
// // //           excessAmt={activeRow.excess_amount}
// // //           onSuccess={handleDialogSuccess}
// // //           onError={showError}
// // //         />
// // //       )}

// // //       {/* Forensic Auditor — report + forward/return */}
// // //       {activeRow && dialogType === 'action' && role === 'forensic_auditor' && (
// // //         <ForensicAuditorActionDialog
// // //           open
// // //           onClose={closeDialogs}
// // //           excessId={activeRow.id}
// // //           refId={activeRow.reference_id}
// // //           excessAmt={activeRow.excess_amount}
// // //           onSuccess={handleDialogSuccess}
// // //           onError={showError}
// // //         />
// // //       )}

// // //       {/* Shirastedar / Tahsildar / AC / CA / SPLOCA — generic forward/return */}
// // //       {activeRow && dialogType === 'action' && isGenericRole && (
// // //         <ForwardReturnDialog
// // //           open
// // //           onClose={closeDialogs}
// // //           excessId={activeRow.id}
// // //           refId={activeRow.reference_id}
// // //           role={role}
// // //           currentStage={activeRow.current_stage}
// // //           stageLabel={STAGE_LABELS[activeRow.current_stage] || activeRow.current_stage}
// // //           onSuccess={handleDialogSuccess}
// // //           onError={showError}
// // //         />
// // //       )}

// // //       {/* Case Worker at pending_payment — reuse the existing manage modal */}
// // //       {activeRow && dialogType === 'manage' && (
// // //         <ExcessManageModal
// // //           open
// // //           onClose={closeDialogs}
// // //           excessId={activeRow.id}
// // //           refId={activeRow.reference_id}
// // //           excessAmt={activeRow.excess_amount}
// // //         />
// // //       )}

// // //       {/* History */}
// // //       {activeRow && dialogType === 'history' && (
// // //         <WorkflowHistoryDialog
// // //           open
// // //           onClose={closeDialogs}
// // //           excessId={activeRow.id}
// // //           refId={activeRow.reference_id}
// // //         />
// // //       )}

// // //       <SnackBarComponent
// // //         open={snackbarOpen}
// // //         message={snackbarMsg}
// // //         severity={snackbarSeverity}
// // //         onClose={() => setSnackbarOpen(false)}
// // //       />
// // //     </Box>
// // //   );
// // // };

// // // export default MyRecordsTable;



// // import React, { useEffect, useState, useCallback } from 'react';
// // import {
// //   Box, Typography, Chip, IconButton, Tooltip, Button,
// //   FormControl, InputLabel, Select, MenuItem,
// // } from '@mui/material';
// // import HistoryIcon from '@mui/icons-material/History';
// // import VisibilityIcon from '@mui/icons-material/Visibility';
// // import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
// // import TableComponent from '../../../Components/TableComponent/TableComponent';
// // import { LoadingSpinner } from '../../../Components/spinner/spinner';
// // import { SnackBarComponent } from '../../../Components/snackBar/snackBar';

// // import {
// //   fetchMyRecords, fetchMyFeList, STAGES, STAGE_LABELS, STAGE_COLORS,
// //   GENERIC_FORWARD_RETURN_ROLES,
// // } from './workflowApi';
// // import CaseWorkerDecisionDialog from './caseworkerDecisionDialog';
// // import ForensicAuditorActionDialog from './forensicAuditorActionDialog';
// // import ForwardReturnDialog from './forwordReturnDialog';
// // import WorkflowHistoryDialog from './workHistoryDialog';
// // import RecordDetailDialog from './recordDetails';
// // import ExcessManageModal from './epmsMgmtModal';

// // const fmtMoney = (n) => `₹ ${Number(n || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`;

// // // Roles that have visibility across multiple FEs and therefore benefit from
// // // an FE filter dropdown. Competent Authority only sees their assigned FEs
// // // (via FeCA); SPLOCA sees every FE.
// // const FE_FILTERABLE_ROLES = new Set(['competent_authority', 'sploca']);

// // // Every record this role has visibility into, regardless of current stage —
// // // full document/order/payment detail on every row, and inline action when
// // // `can_act` says it's actually this role's turn. No search box here — the
// // // TableComponent already provides column-level search/filter.
// // const MyRecordsTable = ({ role, title = 'My Records' }) => {
// //   const [rows, setRows] = useState([]);
// //   const [loading, setLoading] = useState(false);
// //   const [activeRow, setActiveRow] = useState(null);
// //   const [dialogType, setDialogType] = useState(null); // 'action' | 'history' | 'manage' | 'detail'

// //   const [feOptions, setFeOptions] = useState([]);
// //   const [selectedFeId, setSelectedFeId] = useState('');
// //   const isFeFilterable = FE_FILTERABLE_ROLES.has(role);

// //   const [snackbarOpen, setSnackbarOpen] = useState(false);
// //   const [snackbarMsg, setSnackbarMsg] = useState('');
// //   const [snackbarSeverity, setSnackbarSeverity] = useState('info');

// //   const showSuccess = (msg) => { setSnackbarMsg(msg); setSnackbarSeverity('success'); setSnackbarOpen(true); };
// //   const showError = (msg) => { setSnackbarMsg(msg); setSnackbarSeverity('error'); setSnackbarOpen(true); };

// //   useEffect(() => {
// //     if (!isFeFilterable) return;
// //     fetchMyFeList()
// //       .then((res) => setFeOptions(res.data?.results || []))
// //       .catch(() => setFeOptions([]));
// //   }, [isFeFilterable]);

// //   const loadRecords = useCallback(() => {
// //     setLoading(true);
// //     fetchMyRecords({ feId: selectedFeId || undefined })
// //       .then((res) => setRows(res.data?.results || []))
// //       .catch(() => showError('Failed to load records.'))
// //       .finally(() => setLoading(false));
// //   }, [selectedFeId]);

// //   useEffect(() => { loadRecords(); }, [loadRecords]);

// //   const closeDialogs = () => {
// //     setActiveRow(null);
// //     setDialogType(null);
// //   };

// //   const handleDialogSuccess = (msg) => {
// //     showSuccess(msg);
// //     closeDialogs();
// //     loadRecords();
// //   };

// //   const handleActionClick = (row) => {
// //     if (row.current_stage === STAGES.PENDING_PAYMENT || row.current_stage === STAGES.CLOSED) {
// //       setActiveRow(row);
// //       setDialogType('manage');
// //       return;
// //     }
// //     setActiveRow(row);
// //     setDialogType('action');
// //   };

// //   // Payment/Closure is visible to everyone (full transparency across
// //   // roles), but only editable by the Case Worker, and only while still at
// //   // pending_payment — once closed, it's always read-only for everyone.
// //   const showsPaymentButton = (row) =>
// //     row.current_stage === STAGES.PENDING_PAYMENT || row.current_stage === STAGES.CLOSED;

// //   const isPaymentReadOnly = (row) =>
// //     role !== 'case_worker' || row.current_stage === STAGES.CLOSED;

// //   const columns = [
// //     { id: 'reference_id', field: 'reference_id', headerName: 'Reference ID', width: 150 },
// //     { id: 'name', field: 'name', headerName: 'Name', width: 150 },
// //     { id: 'fe_name', field: 'fe_name', headerName: 'FE', width: 150 },
// //     {
// //       id: 'workflow_type', field: 'workflow_type', headerName: 'Workflow', width: 100,
// //       renderCell: (params) => params.row.workflow_type
// //         ? <Chip size="small" label={params.row.workflow_type === 'workflow_1' ? 'WF 1' : 'WF 2'} />
// //         : <Typography variant="caption" color="text.secondary">—</Typography>,
// //     },
// //     {
// //       id: 'current_stage', field: 'current_stage', headerName: 'Stage', width: 200,
// //       renderCell: (params) => (
// //         <Box display="flex" alignItems="center" gap={0.5}>
// //           <Chip
// //             size="small"
// //             label={STAGE_LABELS[params.row.current_stage] || params.row.current_stage}
// //             color={STAGE_COLORS[params.row.current_stage] || 'default'}
// //             sx={{ fontWeight: 600 }}
// //           />
// //           {params.row.is_returned && (
// //             <Chip size="small" label="Returned" color="error" variant="outlined" sx={{ fontWeight: 600 }} />
// //           )}
// //         </Box>
// //       ),
// //     },
// //     {
// //       id: 'agree_to_pay', field: 'agree_to_pay', headerName: 'Agreed to Pay', width: 130,
// //       renderCell: (params) => {
// //         const p = params.row.payment;
// //         if (!p) return <Typography variant="caption" color="text.secondary">—</Typography>;
// //         if (p.is_agreed_to_pay) return <Chip size="small" label="Agreed" color="success" />;
// //         if (p.is_not_agreed_to_pay) return <Chip size="small" label="Not Agreed" color="error" />;
// //         return <Chip size="small" label="Pending" variant="outlined" />;
// //       },
// //     },
// //     {
// //       id: 'agreed_amount', field: 'agreed_amount', headerName: 'Agreed Amount', width: 140,
// //       renderCell: (params) => params.row.payment?.agreed_amount
// //         ? fmtMoney(params.row.payment.agreed_amount)
// //         : <Typography variant="caption" color="text.secondary">—</Typography>,
// //     },
// //     {
// //       id: 'no_of_installment', field: 'no_of_installment', headerName: 'Installments', width: 110,
// //       renderCell: (params) => params.row.payment?.no_of_installment || (
// //         <Typography variant="caption" color="text.secondary">—</Typography>
// //       ),
// //     },
// //     {
// //       id: 'excess_amount', field: 'excess_amount', headerName: 'Excess Amount', width: 130,
// //       renderCell: (params) => fmtMoney(params.row.excess_amount),
// //     },
// //     {
// //       id: 'actions', field: 'actions', headerName: 'Actions', width: 240, sortable: false,
// //       renderCell: (params) => (
// //         <Box display="flex" alignItems="center" gap={0.5}>
// //           <Tooltip title="View full details">
// //             <IconButton size="small" onClick={() => { setActiveRow(params.row); setDialogType('detail'); }}>
// //               <VisibilityIcon fontSize="small" />
// //             </IconButton>
// //           </Tooltip>
// //           {params.row.can_act && !showsPaymentButton(params.row) && (
// //             <Button
// //               size="small"
// //               variant="contained"
// //               startIcon={<AssignmentTurnedInIcon fontSize="small" />}
// //               onClick={() => handleActionClick(params.row)}
// //             >
// //               Act
// //             </Button>
// //           )}
// //           {showsPaymentButton(params.row) && (
// //             <Button
// //               size="small"
// //               variant={isPaymentReadOnly(params.row) ? 'outlined' : 'contained'}
// //               color={isPaymentReadOnly(params.row) ? 'inherit' : 'primary'}
// //               startIcon={isPaymentReadOnly(params.row) ? <VisibilityIcon fontSize="small" /> : <AssignmentTurnedInIcon fontSize="small" />}
// //               onClick={() => handleActionClick(params.row)}
// //             >
// //               {isPaymentReadOnly(params.row) ? 'View Payment' : 'Manage Payment'}
// //             </Button>
// //           )}
// //           <Tooltip title="View History">
// //             <IconButton size="small" onClick={() => { setActiveRow(params.row); setDialogType('history'); }}>
// //               <HistoryIcon fontSize="small" />
// //             </IconButton>
// //           </Tooltip>
// //         </Box>
// //       ),
// //     },
// //   ];

// //   const isGenericRole = GENERIC_FORWARD_RETURN_ROLES.has(role);

// //   return (
// //     <Box sx={{ width: '100%', bgcolor: '#fff', borderRadius: 2, boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }}>
// //       <Box p={2} display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={1.5} bgcolor="rgba(195,234,203,0.1)">
// //         <Typography variant="h6" fontWeight="bold">{title}</Typography>
// //         <Box display="flex" alignItems="center" gap={2}>
// //           {isFeFilterable && (
// //             <FormControl size="small" sx={{ minWidth: 220 }}>
// //               <InputLabel>Filter by FE</InputLabel>
// //               <Select
// //                 label="Filter by FE"
// //                 value={selectedFeId}
// //                 onChange={(e) => setSelectedFeId(e.target.value)}
// //                 displayEmpty
// //               >
// //                 <MenuItem value=""><em>All FE{role === 'sploca' ? ' (State-wide)' : ''}</em></MenuItem>
// //                 {feOptions.map((fe) => (
// //                   <MenuItem key={fe.id} value={fe.id}>{fe.name}</MenuItem>
// //                 ))}
// //               </Select>
// //             </FormControl>
// //           )}
// //           <Typography variant="body2" color="text.secondary">
// //             {rows.length} record(s)
// //           </Typography>
// //         </Box>
// //       </Box>

// //       {loading ? (
// //         <LoadingSpinner size={30} />
// //       ) : rows.length === 0 ? (
// //         <Box p={4} textAlign="center">
// //           <Typography color="text.secondary">No records assigned to you yet.</Typography>
// //         </Box>
// //       ) : (
// //         <TableComponent
// //           columns={columns}
// //           rows={rows}
// //           manageColumnStatus
// //           enableSort
// //           sx={{ '& .MuiDataGrid-columnHeaders': { backgroundColor: '#1976d2', color: '#fff', fontWeight: 'bold' } }}
// //         />
// //       )}

// //       {/* Detail view — always available */}
// //       {activeRow && dialogType === 'detail' && (
// //         <RecordDetailDialog open onClose={closeDialogs} record={activeRow} />
// //       )}

// //       {/* Case Worker — initial decision */}
// //       {activeRow && dialogType === 'action' && role === 'case_worker' && (
// //         <CaseWorkerDecisionDialog
// //           open
// //           onClose={closeDialogs}
// //           excessId={activeRow.id}
// //           refId={activeRow.reference_id}
// //           excessAmt={activeRow.excess_amount}
// //           onSuccess={handleDialogSuccess}
// //           onError={showError}
// //         />
// //       )}

// //       {/* Forensic Auditor — report + forward/return */}
// //       {activeRow && dialogType === 'action' && role === 'forensic_auditor' && (
// //         <ForensicAuditorActionDialog
// //           open
// //           onClose={closeDialogs}
// //           excessId={activeRow.id}
// //           refId={activeRow.reference_id}
// //           excessAmt={activeRow.excess_amount}
// //           onSuccess={handleDialogSuccess}
// //           onError={showError}
// //         />
// //       )}

// //       {/* Shirastedar / Tahsildar / AC / CA / SPLOCA — generic forward/return */}
// //       {activeRow && dialogType === 'action' && isGenericRole && (
// //         <ForwardReturnDialog
// //           open
// //           onClose={closeDialogs}
// //           excessId={activeRow.id}
// //           refId={activeRow.reference_id}
// //           role={role}
// //           currentStage={activeRow.current_stage}
// //           stageLabel={STAGE_LABELS[activeRow.current_stage] || activeRow.current_stage}
// //           onSuccess={handleDialogSuccess}
// //           onError={showError}
// //         />
// //       )}

// //       {/* Case Worker at pending_payment — reuse the existing manage modal */}
// //       {activeRow && dialogType === 'manage' && (
// //         <ExcessManageModal
// //           open
// //           onClose={closeDialogs}
// //           excessId={activeRow.id}
// //           refId={activeRow.reference_id}
// //           excessAmt={activeRow.excess_amount}
// //           readOnly={isPaymentReadOnly(activeRow)}
// //         />
// //       )}

// //       {/* History */}
// //       {activeRow && dialogType === 'history' && (
// //         <WorkflowHistoryDialog
// //           open
// //           onClose={closeDialogs}
// //           excessId={activeRow.id}
// //           refId={activeRow.reference_id}
// //         />
// //       )}

// //       <SnackBarComponent
// //         open={snackbarOpen}
// //         message={snackbarMsg}
// //         severity={snackbarSeverity}
// //         onClose={() => setSnackbarOpen(false)}
// //       />
// //     </Box>
// //   );
// // };

// // export default MyRecordsTable;


// import React, { useEffect, useState, useCallback } from 'react';
// import {
//   Box, Typography, Chip, IconButton, Tooltip, Button,
//   Autocomplete, TextField,
// } from '@mui/material';
// import HistoryIcon from '@mui/icons-material/History';
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
// import SearchOffIcon from '@mui/icons-material/SearchOff';
// import TableComponent from '../../../Components/TableComponent/TableComponent';
// import { LoadingSpinner } from '../../../Components/spinner/spinner';
// import { SnackBarComponent } from '../../../Components/snackBar/snackBar';

// import {
//   fetchMyRecords, fetchMyFeList, STAGES, STAGE_LABELS, STAGE_COLORS,
//   GENERIC_FORWARD_RETURN_ROLES,
// } from './workflowApi';
// import CaseWorkerDecisionDialog from './caseworkerDecisionDialog';
// import ForensicAuditorActionDialog from './forensicAuditorActionDialog';
// import ForwardReturnDialog from './forwordReturnDialog';
// import WorkflowHistoryDialog from './workHistoryDialog';
// import RecordDetailDialog from './recordDetails';
// import ExcessManageModal from './epmsMgmtModal';

// const fmtMoney = (n) => `₹ ${Number(n || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`;

// // Roles that have visibility across multiple FEs and therefore benefit from
// // an FE filter dropdown. Competent Authority only sees their assigned FEs
// // (via FeCA); SPLOCA sees every FE. For both roles, records are NOT loaded
// // until the user actively searches/selects an FE — there is no "all FE"
// // default view anymore.
// const FE_FILTERABLE_ROLES = new Set(['competent_authority', 'sploca']);

// // Every record this role has visibility into, regardless of current stage —
// // full document/order/payment detail on every row, and inline action when
// // `can_act` says it's actually this role's turn. No search box here — the
// // TableComponent already provides column-level search/filter.
// const MyRecordsTable = ({ role, title = 'My Records' }) => {
//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [activeRow, setActiveRow] = useState(null);
//   const [dialogType, setDialogType] = useState(null); // 'action' | 'history' | 'manage' | 'detail'

//   const [feOptions, setFeOptions] = useState([]);
//   // Holds the whole FE object ({ id, name, ... }), not just the id — Autocomplete
//   // needs the object to render the label and to match against feOptions.
//   const [selectedFe, setSelectedFe] = useState(null);
//   const isFeFilterable = FE_FILTERABLE_ROLES.has(role);

//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMsg, setSnackbarMsg] = useState('');
//   const [snackbarSeverity, setSnackbarSeverity] = useState('info');

//   const showSuccess = (msg) => { setSnackbarMsg(msg); setSnackbarSeverity('success'); setSnackbarOpen(true); };
//   const showError = (msg) => { setSnackbarMsg(msg); setSnackbarSeverity('error'); setSnackbarOpen(true); };

//   useEffect(() => {
//     if (!isFeFilterable) return;
//     fetchMyFeList()
//       .then((res) => setFeOptions(res.data?.results || []))
//       .catch(() => setFeOptions([]));
//   }, [isFeFilterable]);

//   const loadRecords = useCallback(() => {
//     // For FE-filterable roles, don't fetch (and don't show) anything until
//     // an FE has actually been picked — no more "all FE" default view.
//     if (isFeFilterable && !selectedFe) {
//       setRows([]);
//       return;
//     }
//     setLoading(true);
//     fetchMyRecords({ feId: selectedFe?.id || undefined })
//       .then((res) => setRows(res.data?.results || []))
//       .catch(() => showError('Failed to load records.'))
//       .finally(() => setLoading(false));
//   }, [selectedFe, isFeFilterable]);

//   useEffect(() => { loadRecords(); }, [loadRecords]);

//   const closeDialogs = () => {
//     setActiveRow(null);
//     setDialogType(null);
//   };

//   const handleDialogSuccess = (msg) => {
//     showSuccess(msg);
//     closeDialogs();
//     loadRecords();
//   };

//   const handleActionClick = (row) => {
//     if (row.current_stage === STAGES.PENDING_PAYMENT || row.current_stage === STAGES.CLOSED) {
//       setActiveRow(row);
//       setDialogType('manage');
//       return;
//     }
//     setActiveRow(row);
//     setDialogType('action');
//   };

//   // Payment/Closure is visible to everyone (full transparency across
//   // roles), but only editable by the Case Worker, and only while still at
//   // pending_payment — once closed, it's always read-only for everyone.
//   const showsPaymentButton = (row) =>
//     row.current_stage === STAGES.PENDING_PAYMENT || row.current_stage === STAGES.CLOSED;

//   const isPaymentReadOnly = (row) =>
//     role !== 'case_worker' || row.current_stage === STAGES.CLOSED;

//   const columns = [
//     { id: 'reference_id', field: 'reference_id', headerName: 'Reference ID', width: 150 },
//     { id: 'name', field: 'name', headerName: 'Name', width: 150 },
//     { id: 'fe_name', field: 'fe_name', headerName: 'FE', width: 150 },
//     {
//       id: 'workflow_type', field: 'workflow_type', headerName: 'Workflow', width: 100,
//       renderCell: (params) => params.row.workflow_type
//         ? <Chip size="small" label={params.row.workflow_type === 'workflow_1' ? 'WF 1' : 'WF 2'} />
//         : <Typography variant="caption" color="text.secondary">—</Typography>,
//     },
//     {
//       id: 'current_stage', field: 'current_stage', headerName: 'Stage', width: 200,
//       renderCell: (params) => (
//         <Box display="flex" alignItems="center" gap={0.5}>
//           <Chip
//             size="small"
//             label={STAGE_LABELS[params.row.current_stage] || params.row.current_stage}
//             color={STAGE_COLORS[params.row.current_stage] || 'default'}
//             sx={{ fontWeight: 600 }}
//           />
//           {params.row.is_returned && (
//             <Chip size="small" label="Returned" color="error" variant="outlined" sx={{ fontWeight: 600 }} />
//           )}
//         </Box>
//       ),
//     },
//     {
//       id: 'agree_to_pay', field: 'agree_to_pay', headerName: 'Agreed to Pay', width: 130,
//       renderCell: (params) => {
//         const p = params.row.payment;
//         if (!p) return <Typography variant="caption" color="text.secondary">—</Typography>;
//         if (p.is_agreed_to_pay) return <Chip size="small" label="Agreed" color="success" />;
//         if (p.is_not_agreed_to_pay) return <Chip size="small" label="Not Agreed" color="error" />;
//         return <Chip size="small" label="Pending" variant="outlined" />;
//       },
//     },
//     {
//       id: 'agreed_amount', field: 'agreed_amount', headerName: 'Agreed Amount', width: 140,
//       renderCell: (params) => params.row.payment?.agreed_amount
//         ? fmtMoney(params.row.payment.agreed_amount)
//         : <Typography variant="caption" color="text.secondary">—</Typography>,
//     },
//     {
//       id: 'no_of_installment', field: 'no_of_installment', headerName: 'Installments', width: 110,
//       renderCell: (params) => params.row.payment?.no_of_installment || (
//         <Typography variant="caption" color="text.secondary">—</Typography>
//       ),
//     },
//     {
//       id: 'excess_amount', field: 'excess_amount', headerName: 'Excess Amount', width: 130,
//       renderCell: (params) => fmtMoney(params.row.excess_amount),
//     },
//     {
//       id: 'actions', field: 'actions', headerName: 'Actions', width: 240, sortable: false,
//       renderCell: (params) => (
//         <Box display="flex" alignItems="center" gap={0.5}>
//           <Tooltip title="View full details">
//             <IconButton size="small" onClick={() => { setActiveRow(params.row); setDialogType('detail'); }}>
//               <VisibilityIcon fontSize="small" />
//             </IconButton>
//           </Tooltip>
//           {params.row.can_act && !showsPaymentButton(params.row) && (
//             <Button
//               size="small"
//               variant="contained"
//               startIcon={<AssignmentTurnedInIcon fontSize="small" />}
//               onClick={() => handleActionClick(params.row)}
//             >
//               Act
//             </Button>
//           )}
//           {showsPaymentButton(params.row) && (
//             <Button
//               size="small"
//               variant={isPaymentReadOnly(params.row) ? 'outlined' : 'contained'}
//               color={isPaymentReadOnly(params.row) ? 'inherit' : 'primary'}
//               startIcon={isPaymentReadOnly(params.row) ? <VisibilityIcon fontSize="small" /> : <AssignmentTurnedInIcon fontSize="small" />}
//               onClick={() => handleActionClick(params.row)}
//             >
//               {isPaymentReadOnly(params.row) ? 'View Payment' : 'Manage Payment'}
//             </Button>
//           )}
//           <Tooltip title="View History">
//             <IconButton size="small" onClick={() => { setActiveRow(params.row); setDialogType('history'); }}>
//               <HistoryIcon fontSize="small" />
//             </IconButton>
//           </Tooltip>
//         </Box>
//       ),
//     },
//   ];

//   const isGenericRole = GENERIC_FORWARD_RETURN_ROLES.has(role);

//   return (
//     <Box sx={{ width: '100%', bgcolor: '#fff', borderRadius: 2, boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }}>
//       <Box p={2} display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={1.5} bgcolor="rgba(195,234,203,0.1)">
//         <Typography variant="h6" fontWeight="bold">{title}</Typography>
//         <Box display="flex" alignItems="center" gap={2}>
//           {isFeFilterable && (
//             <Autocomplete
//               size="small"
//               sx={{ minWidth: 280 }}
//               options={feOptions}
//               getOptionLabel={(fe) => fe?.name || ''}
//               isOptionEqualToValue={(a, b) => a.id === b.id}
//               value={selectedFe}
//               onChange={(_, newValue) => setSelectedFe(newValue)}
//               renderInput={(params) => (
//                 <TextField {...params} label="Search & select FE" placeholder="Type to search..." />
//               )}
//             />
//           )}
//           <Typography variant="body2" color="text.secondary">
//             {rows.length} record(s)
//           </Typography>
//         </Box>
//       </Box>

//       {loading ? (
//         <LoadingSpinner size={30} />
//       ) : isFeFilterable && !selectedFe ? (
//         <Box p={4} textAlign="center">
//           <SearchOffIcon sx={{ fontSize: 40, color: 'text.disabled', mb: 1 }} />
//           <Typography color="text.secondary">
//             Search and select an FE above to view records.
//           </Typography>
//         </Box>
//       ) : rows.length === 0 ? (
//         <Box p={4} textAlign="center">
//           <Typography color="text.secondary">No records assigned to you yet.</Typography>
//         </Box>
//       ) : (
//         <TableComponent
//           columns={columns}
//           rows={rows}
//           manageColumnStatus
//           enableSort
//           sx={{ '& .MuiDataGrid-columnHeaders': { backgroundColor: '#1976d2', color: '#fff', fontWeight: 'bold' } }}
//         />
//       )}

//       {/* Detail view — always available */}
//       {activeRow && dialogType === 'detail' && (
//         <RecordDetailDialog open onClose={closeDialogs} record={activeRow} />
//       )}

//       {/* Case Worker — initial decision */}
//       {activeRow && dialogType === 'action' && role === 'case_worker' && (
//         <CaseWorkerDecisionDialog
//           open
//           onClose={closeDialogs}
//           excessId={activeRow.id}
//           refId={activeRow.reference_id}
//           excessAmt={activeRow.excess_amount}
//           onSuccess={handleDialogSuccess}
//           onError={showError}
//         />
//       )}

//       {/* Forensic Auditor — report + forward/return */}
//       {activeRow && dialogType === 'action' && role === 'forensic_auditor' && (
//         <ForensicAuditorActionDialog
//           open
//           onClose={closeDialogs}
//           excessId={activeRow.id}
//           refId={activeRow.reference_id}
//           excessAmt={activeRow.excess_amount}
//           onSuccess={handleDialogSuccess}
//           onError={showError}
//         />
//       )}

//       {/* Shirastedar / Tahsildar / AC / CA / SPLOCA — generic forward/return */}
//       {activeRow && dialogType === 'action' && isGenericRole && (
//         <ForwardReturnDialog
//           open
//           onClose={closeDialogs}
//           excessId={activeRow.id}
//           refId={activeRow.reference_id}
//           role={role}
//           currentStage={activeRow.current_stage}
//           stageLabel={STAGE_LABELS[activeRow.current_stage] || activeRow.current_stage}
//           onSuccess={handleDialogSuccess}
//           onError={showError}
//         />
//       )}

//       {/* Case Worker at pending_payment — reuse the existing manage modal */}
//       {activeRow && dialogType === 'manage' && (
//         <ExcessManageModal
//           open
//           onClose={closeDialogs}
//           excessId={activeRow.id}
//           refId={activeRow.reference_id}
//           excessAmt={activeRow.excess_amount}
//           readOnly={isPaymentReadOnly(activeRow)}
//         />
//       )}

//       {/* History */}
//       {activeRow && dialogType === 'history' && (
//         <WorkflowHistoryDialog
//           open
//           onClose={closeDialogs}
//           excessId={activeRow.id}
//           refId={activeRow.reference_id}
//         />
//       )}

//       <SnackBarComponent
//         open={snackbarOpen}
//         message={snackbarMsg}
//         severity={snackbarSeverity}
//         onClose={() => setSnackbarOpen(false)}
//       />
//     </Box>
//   );
// };

// export default MyRecordsTable;


// import React, { useEffect, useState, useCallback } from 'react';
// import {
//   Box, Typography, Chip, IconButton, Tooltip, Button,
//   FormControl, InputLabel, Select, MenuItem,
// } from '@mui/material';
// import HistoryIcon from '@mui/icons-material/History';
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
// import TableComponent from '../../../Components/TableComponent/TableComponent';
// import { LoadingSpinner } from '../../../Components/spinner/spinner';
// import { SnackBarComponent } from '../../../Components/snackBar/snackBar';

// import {
//   fetchMyRecords, fetchMyFeList, STAGES, STAGE_LABELS, STAGE_COLORS,
//   GENERIC_FORWARD_RETURN_ROLES,
// } from './workflowApi';
// import CaseWorkerDecisionDialog from './caseworkerDecisionDialog';
// import ForensicAuditorActionDialog from './forensicAuditorActionDialog';
// import ForwardReturnDialog from './forwordReturnDialog';
// import WorkflowHistoryDialog from './workHistoryDialog';
// import RecordDetailDialog from './recordDetails';
// import ExcessManageModal from './epmsMgmtModal';

// const fmtMoney = (n) => `₹ ${Number(n || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`;

// // Roles that have visibility across multiple FEs and therefore benefit from
// // an FE filter dropdown. Competent Authority only sees their assigned FEs
// // (via FeCA); SPLOCA sees every FE.
// // const FE_FILTERABLE_ROLES = new Set(['competent_authority', 'sploca']);
// const FE_FILTERABLE_ROLES = new Set([
//   'competent_authority', 'sploca',
//   'tahsildar', 'assistant_commissioner', 'joint_secretary',
// ]);

// // Every record this role has visibility into, regardless of current stage —
// // full document/order/payment detail on every row, and inline action when
// // `can_act` says it's actually this role's turn. No search box here — the
// // TableComponent already provides column-level search/filter.
// const MyRecordsTable = ({ role, title = 'My Records' }) => {
//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [activeRow, setActiveRow] = useState(null);
//   const [dialogType, setDialogType] = useState(null); // 'action' | 'history' | 'manage' | 'detail'

//   const [feOptions, setFeOptions] = useState([]);
//   const [selectedFeId, setSelectedFeId] = useState('');
//   const isFeFilterable = FE_FILTERABLE_ROLES.has(role);

//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMsg, setSnackbarMsg] = useState('');
//   const [snackbarSeverity, setSnackbarSeverity] = useState('info');

//   const showSuccess = (msg) => { setSnackbarMsg(msg); setSnackbarSeverity('success'); setSnackbarOpen(true); };
//   const showError = (msg) => { setSnackbarMsg(msg); setSnackbarSeverity('error'); setSnackbarOpen(true); };

//   useEffect(() => {
//     if (!isFeFilterable) return;
//     fetchMyFeList()
//       .then((res) => setFeOptions(res.data?.results || []))
//       .catch(() => setFeOptions([]));
//   }, [isFeFilterable]);

//   const loadRecords = useCallback(() => {
//     setLoading(true);
//     fetchMyRecords({ feId: selectedFeId || undefined })
//       .then((res) => setRows(res.data?.results || []))
//       .catch(() => showError('Failed to load records.'))
//       .finally(() => setLoading(false));
//   }, [selectedFeId]);

//   useEffect(() => { loadRecords(); }, [loadRecords]);

//   const closeDialogs = () => {
//     setActiveRow(null);
//     setDialogType(null);
//   };

//   const handleDialogSuccess = (msg) => {
//     showSuccess(msg);
//     closeDialogs();
//     loadRecords();
//   };

//   const handleActionClick = (row) => {
//     if (row.current_stage === STAGES.PENDING_PAYMENT || row.current_stage === STAGES.CLOSED || row.can_manage_payment_early) {
//       setActiveRow(row);
//       setDialogType('manage');
//       return;
//     }
//     setActiveRow(row);
//     setDialogType('action');
//   };

//   // Payment/Closure is visible to everyone (full transparency across
//   // roles), but only editable by the Case Worker, and only while still at
//   // pending_payment — once closed, it's always read-only for everyone.
//   const showsPaymentButton = (row) =>
//     row.current_stage === STAGES.PENDING_PAYMENT || row.current_stage === STAGES.CLOSED || row.can_manage_payment_early;

//   const isPaymentReadOnly = (row) =>
//     role !== 'case_worker' || row.current_stage === STAGES.CLOSED;

//   // Workflow 1 (full lump sum) still moving through Shirastedar/Tahsildar/
//   // AC/CA/SPLOCA — the Case Worker can collect that payment early, but only
//   // Installments, not Documents/Closure (those shouldn't change mid-approval).
//   const isEarlyLumpSumCollection = (row) =>
//     row.can_manage_payment_early && row.current_stage !== STAGES.PENDING_PAYMENT && row.current_stage !== STAGES.CLOSED;

//   const columns = [
//     { id: 'reference_id', field: 'reference_id', headerName: 'Reference ID', width: 150 },
//     { id: 'name', field: 'name', headerName: 'Name', width: 150 },
//     { id: 'fe_name', field: 'fe_name', headerName: 'FE', width: 150 },
//     {
//       id: 'workflow_type', field: 'workflow_type', headerName: 'Workflow', width: 100,
//       renderCell: (params) => params.row.workflow_type
//         ? <Chip size="small" label={params.row.workflow_type === 'workflow_1' ? 'WF 1' : 'WF 2'} />
//         : <Typography variant="caption" color="text.secondary">—</Typography>,
//     },
//     {
//       id: 'current_stage', field: 'current_stage', headerName: 'Stage', width: 200,
//       renderCell: (params) => (
//         <Box display="flex" alignItems="center" gap={0.5}>
//           <Chip
//             size="small"
//             label={STAGE_LABELS[params.row.current_stage] || params.row.current_stage}
//             color={STAGE_COLORS[params.row.current_stage] || 'default'}
//             sx={{ fontWeight: 600 }}
//           />
//           {params.row.is_returned && (
//             <Chip size="small" label="Returned" color="error" variant="outlined" sx={{ fontWeight: 600 }} />
//           )}
//         </Box>
//       ),
//     },
//     {
//       id: 'agree_to_pay', field: 'agree_to_pay', headerName: 'Agreed to Pay', width: 130,
//       renderCell: (params) => {
//         const p = params.row.payment;
//         if (!p) return <Typography variant="caption" color="text.secondary">—</Typography>;
//         if (p.is_agreed_to_pay) return <Chip size="small" label="Agreed" color="success" />;
//         if (p.is_not_agreed_to_pay) return <Chip size="small" label="Not Agreed" color="error" />;
//         return <Chip size="small" label="Pending" variant="outlined" />;
//       },
//     },
//     {
//       id: 'agreed_amount', field: 'agreed_amount', headerName: 'Agreed Amount', width: 140,
//       renderCell: (params) => params.row.payment?.agreed_amount
//         ? fmtMoney(params.row.payment.agreed_amount)
//         : <Typography variant="caption" color="text.secondary">—</Typography>,
//     },
//     {
//       id: 'no_of_installment', field: 'no_of_installment', headerName: 'Installments', width: 110,
//       renderCell: (params) => params.row.payment?.no_of_installment || (
//         <Typography variant="caption" color="text.secondary">—</Typography>
//       ),
//     },
//     {
//       id: 'excess_amount', field: 'excess_amount', headerName: 'Excess Amount', width: 130,
//       renderCell: (params) => fmtMoney(params.row.excess_amount),
//     },
//     {
//       id: 'balance_amount', field: 'balance_amount', headerName: 'Balance (Unpaid)', width: 150,   // <-- ADD THIS COLUMN
//       renderCell: (params) => {
//         const balance = params.row.balance_amount || 0;
//         return (
//           <Typography variant="body2" fontWeight={700} color={balance > 0 ? 'error.main' : 'success.main'}>
//             {fmtMoney(balance)}
//           </Typography>
//         );
//       },
//     },
//     {
//       id: 'actions', field: 'actions', headerName: 'Actions', width: 240, sortable: false,
//       renderCell: (params) => (
//         <Box display="flex" alignItems="center" gap={0.5}>
//           <Tooltip title="View full details">
//             <IconButton size="small" onClick={() => { setActiveRow(params.row); setDialogType('detail'); }}>
//               <VisibilityIcon fontSize="small" />
//             </IconButton>
//           </Tooltip>
//           {params.row.can_act && !showsPaymentButton(params.row) && (
//             <Button
//               size="small"
//               variant="contained"
//               startIcon={<AssignmentTurnedInIcon fontSize="small" />}
//               onClick={() => handleActionClick(params.row)}
//             >
//               Act
//             </Button>
//           )}
//           {showsPaymentButton(params.row) && (
//             <Button
//               size="small"
//               variant={isPaymentReadOnly(params.row) ? 'outlined' : 'contained'}
//               color={isPaymentReadOnly(params.row) ? 'inherit' : (isEarlyLumpSumCollection(params.row) ? 'warning' : 'primary')}
//               startIcon={isPaymentReadOnly(params.row) ? <VisibilityIcon fontSize="small" /> : <AssignmentTurnedInIcon fontSize="small" />}
//               onClick={() => handleActionClick(params.row)}
//             >
//               {isPaymentReadOnly(params.row)
//                 ? 'View Payment'
//                 : isEarlyLumpSumCollection(params.row)
//                   ? 'Collect Payment'
//                   : 'Manage Payment'}
//             </Button>
//           )}
//           <Tooltip title="View History">
//             <IconButton size="small" onClick={() => { setActiveRow(params.row); setDialogType('history'); }}>
//               <HistoryIcon fontSize="small" />
//             </IconButton>
//           </Tooltip>
//         </Box>
//       ),
//     },
//   ];

//   const isGenericRole = GENERIC_FORWARD_RETURN_ROLES.has(role);

//   return (
//     <Box sx={{ width: '100%', bgcolor: '#fff', borderRadius: 2, boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }}>
//       <Box p={2} display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={1.5} bgcolor="rgba(195,234,203,0.1)">
//         <Typography variant="h6" fontWeight="bold">{title}</Typography>
//         <Box display="flex" alignItems="center" gap={2}>
//           {isFeFilterable && (
//             <FormControl size="small" sx={{ minWidth: 220 }}>
//               <InputLabel>Filter by FE</InputLabel>
//               <Select
//                 label="Filter by FE"
//                 value={selectedFeId}
//                 onChange={(e) => setSelectedFeId(e.target.value)}
//                 displayEmpty
//               >
//                 <MenuItem value=""><em>All FE{role === 'sploca' ? ' (State-wide)' : ''}</em></MenuItem>
//                 {feOptions.map((fe) => (
//                   <MenuItem key={fe.id} value={fe.id}>{fe.name}</MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           )}
//           <Typography variant="body2" color="text.secondary">
//             {rows.length} record(s)
//           </Typography>
//         </Box>
//       </Box>

//       {loading ? (
//         <LoadingSpinner size={30} />
//       ) : rows.length === 0 ? (
//         <Box p={4} textAlign="center">
//           <Typography color="text.secondary">No records assigned to you yet.</Typography>
//         </Box>
//       ) : (
//         <TableComponent
//           columns={columns}
//           rows={rows}
//           manageColumnStatus
//           enableSort
//           sx={{ '& .MuiDataGrid-columnHeaders': { backgroundColor: '#1976d2', color: '#fff', fontWeight: 'bold' } }}
//         />
//       )}

//       {/* Detail view — always available */}
//       {activeRow && dialogType === 'detail' && (
//         <RecordDetailDialog open onClose={closeDialogs} record={activeRow} />
//       )}

//       {/* Case Worker — initial decision */}
//       {activeRow && dialogType === 'action' && role === 'case_worker' && (
//         <CaseWorkerDecisionDialog
//           open
//           onClose={closeDialogs}
//           excessId={activeRow.id}
//           refId={activeRow.reference_id}
//           excessAmt={activeRow.excess_amount}
//           onSuccess={handleDialogSuccess}
//           onError={showError}
//         />
//       )}

//       {/* Forensic Auditor — report + forward/return */}
//       {activeRow && dialogType === 'action' && role === 'forensic_auditor' && (
//         <ForensicAuditorActionDialog
//           open
//           onClose={closeDialogs}
//           excessId={activeRow.id}
//           refId={activeRow.reference_id}
//           excessAmt={activeRow.excess_amount}
//           onSuccess={handleDialogSuccess}
//           onError={showError}
//         />
//       )}

//       {/* Shirastedar / Tahsildar / AC / CA / SPLOCA — generic forward/return */}
//       {activeRow && dialogType === 'action' && isGenericRole && (
//         <ForwardReturnDialog
//           open
//           onClose={closeDialogs}
//           excessId={activeRow.id}
//           refId={activeRow.reference_id}
//           role={role}
//           currentStage={activeRow.current_stage}
//           stageLabel={STAGE_LABELS[activeRow.current_stage] || activeRow.current_stage}
//           onSuccess={handleDialogSuccess}
//           onError={showError}
//         />
//       )}

//       {/* Case Worker at pending_payment (or early WF1 lump-sum collection) — reuse the existing manage modal */}
//       {activeRow && dialogType === 'manage' && (
//         <ExcessManageModal
//           open
//           onClose={closeDialogs}
//           excessId={activeRow.id}
//           refId={activeRow.reference_id}
//           excessAmt={activeRow.excess_amount}
//           readOnly={isPaymentReadOnly(activeRow)}
//           installmentsOnly={isEarlyLumpSumCollection(activeRow)}
//         />
//       )}

//       {/* History */}
//       {activeRow && dialogType === 'history' && (
//         <WorkflowHistoryDialog
//           open
//           onClose={closeDialogs}
//           excessId={activeRow.id}
//           refId={activeRow.reference_id}
//         />
//       )}

//       <SnackBarComponent
//         open={snackbarOpen}
//         message={snackbarMsg}
//         severity={snackbarSeverity}
//         onClose={() => setSnackbarOpen(false)}
//       />
//     </Box>
//   );
// };

// export default MyRecordsTable;

import React, { useEffect, useState, useCallback } from 'react';
import {
  Box, Typography, Chip, IconButton, Tooltip, Button,
  Autocomplete, TextField,
} from '@mui/material';
import HistoryIcon from '@mui/icons-material/History';
import VisibilityIcon from '@mui/icons-material/Visibility';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import TableComponent from '../../../Components/TableComponent/TableComponent';
import { LoadingSpinner } from '../../../Components/spinner/spinner';
import { SnackBarComponent } from '../../../Components/snackBar/snackBar';

import {
  fetchMyRecords, fetchMyFeList, STAGES, STAGE_LABELS, STAGE_COLORS,
  GENERIC_FORWARD_RETURN_ROLES,
} from './workflowApi';
import CaseWorkerDecisionDialog from './caseworkerDecisionDialog';
import ForensicAuditorActionDialog from './forensicAuditorActionDialog';
import ForwardReturnDialog from './forwordReturnDialog';
import WorkflowHistoryDialog from './workHistoryDialog';
import RecordDetailDialog from './recordDetails';
import ExcessManageModal from './epmsMgmtModal';

const fmtMoney = (n) => `₹ ${Number(n || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`;

// Roles that have visibility across multiple FEs and therefore benefit from
// an FE filter dropdown. Competent Authority only sees their assigned FEs
// (via FeCA); SPLOCA sees every FE.
const FE_FILTERABLE_ROLES = new Set([
  'competent_authority', 'sploca',
  'tahsildar', 'assistant_commissioner', 'joint_secretary',
]);

// Every record this role has visibility into, regardless of current stage —
// full document/order/payment detail on every row, and inline action when
// `can_act` says it's actually this role's turn. No search box here — the
// TableComponent already provides column-level search/filter.
const MyRecordsTable = ({ role, title = 'My Records' }) => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activeRow, setActiveRow] = useState(null);
  const [dialogType, setDialogType] = useState(null); // 'action' | 'history' | 'manage' | 'detail'

  const [feOptions, setFeOptions] = useState([]);
  const [selectedFe, setSelectedFe] = useState(null); // full FE object or null
  const isFeFilterable = FE_FILTERABLE_ROLES.has(role);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('info');

  const showSuccess = (msg) => { setSnackbarMsg(msg); setSnackbarSeverity('success'); setSnackbarOpen(true); };
  const showError = (msg) => { setSnackbarMsg(msg); setSnackbarSeverity('error'); setSnackbarOpen(true); };

  useEffect(() => {
    if (!isFeFilterable) return;
    fetchMyFeList()
      .then((res) => setFeOptions(res.data?.results || []))
      .catch(() => setFeOptions([]));
  }, [isFeFilterable]);

  const loadRecords = useCallback(() => {
    setLoading(true);
    // Only pass feId once the user has actually picked one from the
    // search box — no more "All FE" pseudo-option driving this.
    fetchMyRecords({ feId: selectedFe?.id || undefined })
      .then((res) => setRows(res.data?.results || []))
      .catch(() => showError('Failed to load records.'))
      .finally(() => setLoading(false));
  }, [selectedFe]);

  useEffect(() => { loadRecords(); }, [loadRecords]);

  const closeDialogs = () => {
    setActiveRow(null);
    setDialogType(null);
  };

  const handleDialogSuccess = (msg) => {
    showSuccess(msg);
    closeDialogs();
    loadRecords();
  };

  const handleActionClick = (row) => {
    if (row.current_stage === STAGES.PENDING_PAYMENT || row.current_stage === STAGES.CLOSED || row.can_manage_payment_early) {
      setActiveRow(row);
      setDialogType('manage');
      return;
    }
    setActiveRow(row);
    setDialogType('action');
  };

  // Payment/Closure is visible to everyone (full transparency across
  // roles), but only editable by the Case Worker, and only while still at
  // pending_payment — once closed, it's always read-only for everyone.
  const showsPaymentButton = (row) =>
    row.current_stage === STAGES.PENDING_PAYMENT || row.current_stage === STAGES.CLOSED || row.can_manage_payment_early;

  const isPaymentReadOnly = (row) =>
    role !== 'case_worker' || row.current_stage === STAGES.CLOSED;

  // Workflow 1 (full lump sum) still moving through Shirastedar/Tahsildar/
  // AC/CA/SPLOCA — the Case Worker can collect that payment early, but only
  // Installments, not Documents/Closure (those shouldn't change mid-approval).
  const isEarlyLumpSumCollection = (row) =>
    row.can_manage_payment_early && row.current_stage !== STAGES.PENDING_PAYMENT && row.current_stage !== STAGES.CLOSED;

  const columns = [
    { id: 'reference_id', field: 'reference_id', headerName: 'Reference ID', width: 150 },
    { id: 'name', field: 'name', headerName: 'Name', width: 150 },
    { id: 'fe_name', field: 'fe_name', headerName: 'FE', width: 150 },
    {
      id: 'workflow_type', field: 'workflow_type', headerName: 'Workflow', width: 100,
      renderCell: (params) => params.row.workflow_type
        ? <Chip size="small" label={params.row.workflow_type === 'workflow_1' ? 'WF 1' : 'WF 2'} />
        : <Typography variant="caption" color="text.secondary">—</Typography>,
    },
    {
      id: 'current_stage', field: 'current_stage', headerName: 'Stage', width: 200,
      renderCell: (params) => (
        <Box display="flex" alignItems="center" gap={0.5}>
          <Chip
            size="small"
            label={STAGE_LABELS[params.row.current_stage] || params.row.current_stage}
            color={STAGE_COLORS[params.row.current_stage] || 'default'}
            sx={{ fontWeight: 600 }}
          />
          {params.row.is_returned && (
            <Chip size="small" label="Returned" color="error" variant="outlined" sx={{ fontWeight: 600 }} />
          )}
        </Box>
      ),
    },
    {
      id: 'agree_to_pay', field: 'agree_to_pay', headerName: 'Agreed to Pay', width: 130,
      renderCell: (params) => {
        const p = params.row.payment;
        if (!p) return <Typography variant="caption" color="text.secondary">—</Typography>;
        if (p.is_agreed_to_pay) return <Chip size="small" label="Agreed" color="success" />;
        if (p.is_not_agreed_to_pay) return <Chip size="small" label="Not Agreed" color="error" />;
        return <Chip size="small" label="Pending" variant="outlined" />;
      },
    },
    {
      id: 'agreed_amount', field: 'agreed_amount', headerName: 'Agreed Amount', width: 140,
      renderCell: (params) => params.row.payment?.agreed_amount
        ? fmtMoney(params.row.payment.agreed_amount)
        : <Typography variant="caption" color="text.secondary">—</Typography>,
    },
    {
      id: 'no_of_installment', field: 'no_of_installment', headerName: 'Installments', width: 110,
      renderCell: (params) => params.row.payment?.no_of_installment || (
        <Typography variant="caption" color="text.secondary">—</Typography>
      ),
    },
    {
      id: 'excess_amount', field: 'excess_amount', headerName: 'Excess Amount', width: 130,
      renderCell: (params) => fmtMoney(params.row.excess_amount),
    },
    {
      id: 'balance_amount', field: 'balance_amount', headerName: 'Balance (Unpaid)', width: 150,
      renderCell: (params) => {
        const balance = params.row.balance_amount || 0;
        return (
          <Typography variant="body2" fontWeight={700} color={balance > 0 ? 'error.main' : 'success.main'}>
            {fmtMoney(balance)}
          </Typography>
        );
      },
    },
    {
      id: 'actions', field: 'actions', headerName: 'Actions', width: 240, sortable: false,
      renderCell: (params) => (
        <Box display="flex" alignItems="center" gap={0.5}>
          <Tooltip title="View full details">
            <IconButton size="small" onClick={() => { setActiveRow(params.row); setDialogType('detail'); }}>
              <VisibilityIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          {params.row.can_act && !showsPaymentButton(params.row) && (
            <Button
              size="small"
              variant="contained"
              startIcon={<AssignmentTurnedInIcon fontSize="small" />}
              onClick={() => handleActionClick(params.row)}
            >
              Act
            </Button>
          )}
          {showsPaymentButton(params.row) && (
            <Button
              size="small"
              variant={isPaymentReadOnly(params.row) ? 'outlined' : 'contained'}
              color={isPaymentReadOnly(params.row) ? 'inherit' : (isEarlyLumpSumCollection(params.row) ? 'warning' : 'primary')}
              startIcon={isPaymentReadOnly(params.row) ? <VisibilityIcon fontSize="small" /> : <AssignmentTurnedInIcon fontSize="small" />}
              onClick={() => handleActionClick(params.row)}
            >
              {isPaymentReadOnly(params.row)
                ? 'View Payment'
                : isEarlyLumpSumCollection(params.row)
                  ? 'Collect Payment'
                  : 'Manage Payment'}
            </Button>
          )}
          <Tooltip title="View History">
            <IconButton size="small" onClick={() => { setActiveRow(params.row); setDialogType('history'); }}>
              <HistoryIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>
      ),
    },
  ];

  const isGenericRole = GENERIC_FORWARD_RETURN_ROLES.has(role);

  return (
    <Box sx={{ width: '100%', bgcolor: '#fff', borderRadius: 2, boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }}>
      <Box p={2} display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={1.5} bgcolor="rgba(195,234,203,0.1)">
        <Typography variant="h6" fontWeight="bold">{title}</Typography>
        <Box display="flex" alignItems="center" gap={2}>
          {isFeFilterable && (
            <Autocomplete
              size="small"
              sx={{ minWidth: 260 }}
              options={feOptions}
              getOptionLabel={(option) => option?.name || ''}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              value={selectedFe}
              onChange={(_, newValue) => setSelectedFe(newValue)}
              renderInput={(params) => (
                <TextField {...params} label="Search FE" placeholder="Type to search FE..." />
              )}
              clearOnEscape
            />
          )}
          <Typography variant="body2" color="text.secondary">
            {rows.length} record(s)
          </Typography>
        </Box>
      </Box>

      {loading ? (
        <LoadingSpinner size={30} />
      ) : rows.length === 0 ? (
        <Box p={4} textAlign="center">
          <Typography color="text.secondary">No records assigned to you yet.</Typography>
        </Box>
      ) : (
        <TableComponent
          columns={columns}
          rows={rows}
          manageColumnStatus
          enableSort
          sx={{ '& .MuiDataGrid-columnHeaders': { backgroundColor: '#1976d2', color: '#fff', fontWeight: 'bold' } }}
        />
      )}

      {/* Detail view — always available */}
      {activeRow && dialogType === 'detail' && (
        <RecordDetailDialog open onClose={closeDialogs} record={activeRow} />
      )}

      {/* Case Worker — initial decision */}
      {activeRow && dialogType === 'action' && role === 'case_worker' && (
        <CaseWorkerDecisionDialog
          open
          onClose={closeDialogs}
          excessId={activeRow.id}
          refId={activeRow.reference_id}
          excessAmt={activeRow.excess_amount}
          onSuccess={handleDialogSuccess}
          onError={showError}
        />
      )}

      {/* Forensic Auditor — report + forward/return */}
      {activeRow && dialogType === 'action' && role === 'forensic_auditor' && (
        <ForensicAuditorActionDialog
          open
          onClose={closeDialogs}
          excessId={activeRow.id}
          refId={activeRow.reference_id}
          excessAmt={activeRow.excess_amount}
          onSuccess={handleDialogSuccess}
          onError={showError}
        />
      )}

      {/* Shirastedar / Tahsildar / AC / CA / SPLOCA — generic forward/return */}
      {activeRow && dialogType === 'action' && isGenericRole && (
        <ForwardReturnDialog
          open
          onClose={closeDialogs}
          excessId={activeRow.id}
          refId={activeRow.reference_id}
          role={role}
          currentStage={activeRow.current_stage}
          stageLabel={STAGE_LABELS[activeRow.current_stage] || activeRow.current_stage}
          onSuccess={handleDialogSuccess}
          onError={showError}
        />
      )}

      {/* Case Worker at pending_payment (or early WF1 lump-sum collection) — reuse the existing manage modal */}
      {activeRow && dialogType === 'manage' && (
        <ExcessManageModal
          open
          onClose={closeDialogs}
          excessId={activeRow.id}
          refId={activeRow.reference_id}
          excessAmt={activeRow.excess_amount}
          readOnly={isPaymentReadOnly(activeRow)}
          installmentsOnly={isEarlyLumpSumCollection(activeRow)}
        />
      )}

      {/* History */}
      {activeRow && dialogType === 'history' && (
        <WorkflowHistoryDialog
          open
          onClose={closeDialogs}
          excessId={activeRow.id}
          refId={activeRow.reference_id}
        />
      )}

      <SnackBarComponent
        open={snackbarOpen}
        message={snackbarMsg}
        severity={snackbarSeverity}
        onClose={() => setSnackbarOpen(false)}
      />
    </Box>
  );
};

export default MyRecordsTable;